import React from 'react';
import EmployeeActions from 'actions/EmployeeActions.js';

export default class CalendarView {
  initializeCalendar(currentDate = moment(Date.now()).toDate(), collection) {
    if (document.querySelector('.month')) {
      this.currentDate = currentDate;
      this.setUpCalendar(this.currentDate);
      this.setUpCalendarToggles();
      this.initialized = true;
      this.deeplinkDay = -1;
    }
  }

  setCurrentDate(date) {
    Utils.setCurrentDate(date);
    this.currentDate = date;
  }

  getCurrentDate() {
    return Utils.getCurrentDate();
  }

  setUpCalendar(date = moment(Date.now()).toDate()) {
    if (moment(date).format('M') !== moment(this.currentDate).format('M') || !this.initialized) {
      Utils.replaceElementWithSpinner(document.querySelector('.month'));

      this.currentDate = date;
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var today = moment(date);
      var month = parseInt(today.format('M'));
      var day = parseInt(today.format('D'));
      var dayText = days[parseInt(today.day())];
      var year = parseInt(today.format('Y'));
      var daysInThisMonth = this.daysInMonth(month - 1, year);
      var lastMonth = month - 2;
      var lastYear = year;
      var daysInLastMonth = this.daysInMonth(lastMonth, lastYear);
      var firstDayThisMonth = this.firstDayOfTheMonth(month, year);

      this.setCurrentDate(date);

      document.getElementById('month-label').innerHTML = moment(new Date(`${months[month - 1]} 1 ${year}`)).format('MMMM Y');

      if (
        month !== parseInt(moment(Date.now()).format('M')) ||
        year !== parseInt(moment(Date.now()).format('Y'))
      ) {
        this.buildCalendar(firstDayThisMonth, daysInThisMonth, daysInLastMonth, month, year);
      } else {
        if (month === parseInt(moment(Date.now()).format('M'))) {
          day = parseInt(moment(Date.now()).format('D'));
        }
        this.buildCalendar(firstDayThisMonth, daysInThisMonth, daysInLastMonth, month, year, day);
      }

      //need to get id from store or session
      var startDate = moment(
        new Date(parseInt(today.format('Y')), parseInt(today.format('M')), 1),
      ).add(-1, 'month');
      //removing logic to only load data from today forward even though it was asked for.
      //this is related to issue #2633
      //if (startDate.isBefore(Date.now())) {
      //startDate = moment(new Date().setHours(0,0,0,0))
      //}
      startDate = startDate.format();
      var startDateToday = moment(new Date()).format();
      var beginingOfTime = moment([1980, 0, 1]).format();
      var endDate = moment(startDate)
        .endOf('month')
        .format();
      var endOfTime = moment(new Date())
        .add(1, 'year')
        .format();

      if (EmployeeActions) {
        EmployeeActions.getShifts(startDate, endDate);
        EmployeeActions.getAllShifts(startDateToday, endOfTime);
        EmployeeActions.getUnavailables(startDate, endDate);
        EmployeeActions.getUnavailableTypes();
        EmployeeActions.getAvailables(startDate, endDate);
        EmployeeActions.getExchanges(startDate, endDate);
        EmployeeActions.getAllExchanges(startDateToday, endOfTime);
      }
    }
  }

  getSixMonthsOfData(date = moment(Date.now())) {
    if (document.querySelector('.month')) {
      this.currentDate = date;
      this.setUpCalendarToggles();
      var startDate = moment([date.format('Y'), date.format('M')]).add(-1, 'month');
      if (startDate.isBefore(Date.now())) {
        startDate = moment(Date.now());
      }
      startDate = startDate.format();
      var endDate = moment(startDate)
        .add(6, 'months')
        .format();

      if (EmployeeActions) {
        EmployeeActions.getShifts(startDate, endDate);
      }
    }
  }

  buildCalendar(firstDayOffset = 0, totalDays = 30, daysInLastMonth = 30, month, year, today) {
    Utils.checkFetchedUser();
    var todayElement = document.querySelector('.month .day.today');
    if (todayElement != null && this.hasClass(todayElement, 'today')) {
      this.removeClass(todayElement, 'today');
    }

    var len = totalDays;
    var lastNum = 0;

    document.querySelector('.month .week:last-child').style.display = 'flex';

    var allDays = document.querySelectorAll('.month .day');
    var weekCount = 0;
    for (var i = 0; i < allDays.length; i++) {
      allDays[i].classList.add('initial');
      allDays[i].setAttribute('data-month', 'current');
      allDays[i].classList.remove('requested');
      allDays[i].classList.remove('deeplink');
      allDays[i].classList.remove('exchanged');
      allDays[i].classList.remove('selected');
      allDays[i].classList.remove('active');
      this.removeClass(allDays[i], 'today');

      Utils.fadeOutElements(allDays[i].querySelectorAll('.shift'));
      var num = i + 1 - firstDayOffset;

      weekCount++;
      if (weekCount > 6) {
        var weekID = Math.ceil(num / 7);
        var currentWeek = document.querySelectorAll('.month .week')[weekID - 1];

        var startDay = num - 6;
        if (startDay < 1) {
          startDay = 1;
        }

        var endDay = num;
        if (endDay > totalDays) {
          endDay = totalDays;
        }

        var weekStr = startDay + '-' + endDay;
        if (startDay <= totalDays) {
          currentWeek.setAttribute('data-day-range', weekStr);
        }
        weekCount = 0;
      }
      allDays[i].setAttribute(
        'data-full-date',
        year + '-' + this.padNumber(month) + '-' + this.padNumber(num),
      );
      if (!Utils.isNotDefined(today) && !isNaN(today) && today === num) {
        this.addClass(allDays[i], 'today');
      }
      if (this.deeplinkDay != -1 && !isNaN(this.deeplinkDay) && this.deeplinkDay === num) {
        this.addClass(allDays[i], 'deeplink');
        this.deeplinkDay = -1;
      }
      if (num <= 0) {
        var tempYear = year;
        var tempMonth = month;
        if (month == 1) {
          tempYear -= 1
          tempMonth = 13;
        }
        num = daysInLastMonth - (firstDayOffset - (i + 1));
        allDays[i].setAttribute('data-month', 'last');
        allDays[i].setAttribute(
          'data-full-date',
          tempYear + '-' + this.padNumber(tempMonth - 1) + '-' + this.padNumber(num),
        );
      } else if (num > totalDays) {
        var tempYear = year;
        var tempMonth = month;
        if (month == 12) {
          tempYear += 1
          tempMonth = 0;
        }
        num = i + 1 - firstDayOffset - totalDays;
        allDays[i].setAttribute(
          'data-full-date',
          tempYear + '-' + this.padNumber(tempMonth + 1) + '-' + this.padNumber(num),
        );
        allDays[i].setAttribute('data-month', 'next');
      }

      allDays[i].setAttribute('data-date', num);
    }

    const getNumWeeksForMonth = (year, month) => {
      const date = new Date(year,month - 1,1);
      const day = date.getDay();
      const numDaysInMonth = new Date(year, month, 0).getDate();
      return Math.ceil((numDaysInMonth + day) / 7);
    }

    const lastWeek = document.querySelector('#week7');
    const secondLastWeek = document.querySelector('#week6')

    lastWeek.style.display = 'none';
    lastWeek.removeAttribute('data-day-range');

    if (getNumWeeksForMonth(year, month) < 6) {
      secondLastWeek.style.display = 'none';
      secondLastWeek.removeAttribute('data-day-range');
    } else {
      secondLastWeek.style.display = '';
    }
  }

  resetInitial() {}

  padNumber(num) {
    if (num < 10 && num >= 0) {
      num = '0' + num;
    }
    return num;
  }

  daysInMonth(month, year) {
    if (month < 0) {
      month = 11;
      year -= 1;
    }
    var monthObj = moment([year, month]).add(0, 'month');
    return monthObj.endOf('month').format('D');
  }

  firstDayOfTheMonth(month, year) {
    return moment(year + '-' + month, 'YYYY-MM').day();
  }

  setUpCalendarToggles() {
    var prev = document.querySelector('#month-toggle #previous-month');

    if (!Utils.isNotDefined(prev)) {
      prev.addEventListener('click', e => {
        this.loadPreviousMonth(e);
      });
    }

    var next = document.querySelector('#month-toggle #next-month');
    if (!Utils.isNotDefined(next)) {
      next.addEventListener('click', e => {
        this.loadNextMonth(e);
      });
    }

    var today = document.querySelector('#month-toggle #today-button');
    if (!Utils.isNotDefined(today)) {
      today.addEventListener('click', e => {
        this.loadCurrentMonth(e);
      });
    }
  }

  gotoDate(date, deeplink = false) {
    if (EmployeeActions) {
      EmployeeActions.clearCalendar();
    }
    var gotoMoment = moment(date);
    var gotoMonth = parseInt(gotoMoment.format('M'));
    var gotoYear = parseInt(gotoMoment.format('Y'));
    if (deeplink) {
      this.deeplinkDay = parseInt(gotoMoment.format('D'));
    }

    this.setUpCalendar(moment(gotoYear + '-' + gotoMonth + '-1', 'YYYY-M-D').format());
  }

  loadPreviousMonth() {
    if (EmployeeActions) {
      EmployeeActions.clearCalendar();
    }
    var myMoment = moment(this.getCurrentDate());
    var currentMonth = parseInt(myMoment.format('M'));
    var currentYear = parseInt(myMoment.format('Y'));
    var newMonth = currentMonth - 1;
    if (newMonth < 1) {
      currentYear -= 1;
      newMonth = '12';
    }
    this.setUpCalendar(moment(currentYear + '-' + newMonth + '-1', 'YYYY-M-D').format());
  }

  loadNextMonth() {
    if (EmployeeActions) {
      EmployeeActions.clearCalendar();
    }
    var myMoment = moment(this.getCurrentDate());
    var currentMonth = parseInt(myMoment.format('M'));
    var currentYear = parseInt(myMoment.format('Y'));
    var newMonth = currentMonth + 1;
    if (newMonth > 12) {
      currentYear += 1;
      newMonth = 1;
    }
    this.setUpCalendar(moment(currentYear + '-' + newMonth + '-1', 'YYYY-M-D').format());
  }

  loadCurrentMonth() {
    this.setUpCalendar(moment(Date.now()).toDate());
  }

  hasClass(el, className) {
    if (el.classList) {
      return el.classList.contains(className);
    } else {
      return !!el.className.match(new RegExp('(\\s|^)${className}(\\s|$)'));
    }
  }

  addClass(el, className) {
    if (el.classList) {
      el.classList.add(className);
    } else if (!hasClass(el, className)) {
      el.className += ' ' + className;
    }
  }

  removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else if (hasClass(el, className)) {
      var reg = new RegExp('(\\s|^)${className}(\\s|$)');
      el.className = el.className.replace(reg, ' ');
    }
  }
}

if (React) {
  document.addEventListener('DOMContentLoaded', function() {
    //var c = new CalendarView();
    //c.initializeCalendar(moment(Date.now()).toDate());
  });
}
